import React, { useState } from 'react';
import { Form, Input, Button, message, Typography, Card } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined, PhoneOutlined, BulbOutlined, BulbFilled } from '@ant-design/icons';
import { useTheme } from '../context/ThemeContext';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const { Title } = Typography;

const RegisterPage = () => {
  const { theme, toggleTheme } = useTheme();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // 只传递后端需要的字段，不包含confirmPassword
      const registerData = {
        username: values.username,
        password: values.password,
        email: values.email,
        phone: values.phone
      };
      
      // 日志记录：显示准备发送的数据
      console.log('注册请求数据:', registerData);
      
      // 日志记录：显示请求URL和配置
      console.log('注册请求URL:', '/auth/register');
      
      const response = await axios.post('/auth/register', registerData);
      
      // 日志记录：显示完整响应
      console.log('注册响应完整数据:', response);
      console.log('注册响应状态码:', response.status);
      console.log('注册响应数据:', response.data);
      
      if (response.data.code === 200) {
        // 保存Token到本地存储
        localStorage.setItem('accessToken', response.data.data.accessToken);
        localStorage.setItem('refreshToken', response.data.data.refreshToken);
        
        // 显示成功消息
        message.success('注册成功');
        
        // 跳转到主页
        navigate('/');
      } else {
        console.error('注册失败，后端返回非200状态:', response.data);
        message.error(response.data.message || '注册失败');
      }
    } catch (error) {
      // 详细的错误日志记录
      console.error('注册请求异常:', error);
      if (error.response) {
        console.error('响应错误状态:', error.response.status);
        console.error('响应错误数据:', error.response.data);
        message.error(error.response.data.message || '注册失败');
      } else if (error.request) {
        console.error('请求已发送但未收到响应:', error.request);
        message.error('网络错误，请稍后重试');
      } else {
        console.error('请求配置错误:', error.message);
        message.error('请求配置错误，请稍后重试');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <Card className="register-form" style={{ position: 'relative' }}>
        <div style={{ position: 'absolute', top: '16px', right: '16px', zIndex: 10 }}>
          <Button
            type="text"
            icon={theme === 'dark' ? <BulbFilled /> : <BulbOutlined />}
            onClick={toggleTheme}
            title={theme === 'dark' ? '切换到浅色模式' : '切换到暗黑模式'}
          />
        </div>
        <Title level={2} className="register-form-title">用户注册</Title>
        <Form
          form={form}
          name="register"
          onFinish={onFinish}
          scrollToFirstError
        >
          <Form.Item
            name="username"
            className="form-item-margin"
            rules={[
              { required: true, message: '请输入用户名!' },
              { min: 4, message: '用户名至少4个字符' },
              { max: 50, message: '用户名最多50个字符' }
            ]}
          >
            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="用户名" />
          </Form.Item>
          
          <Form.Item
            name="password"
            className="form-item-margin"
            rules={[
              { required: true, message: '请输入密码!' },
              { min: 6, message: '密码至少6个字符' }
            ]}
            hasFeedback
          >
            <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="密码" />
          </Form.Item>
          
          <Form.Item
            name="confirmPassword"
            className="form-item-margin"
            dependencies={['password']}
            hasFeedback
            rules={[
              { required: true, message: '请确认密码!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致!'));
                },
              }),
            ]}
          >
            <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="确认密码" />
          </Form.Item>
          
          <Form.Item
            name="email"
            className="form-item-margin"
            rules={[
              { required: true, message: '请输入邮箱!' },
              { type: 'email', message: '邮箱格式不正确!' }
            ]}
          >
            <Input prefix={<MailOutlined className="site-form-item-icon" />} placeholder="邮箱" />
          </Form.Item>
          
          <Form.Item
            name="phone"
            className="form-item-margin"
            rules={[
              { required: false },
              { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确!' }
            ]}
          >
            <Input prefix={<PhoneOutlined className="site-form-item-icon" />} placeholder="手机号（选填）" />
          </Form.Item>
          
          <Form.Item className="form-item-margin">
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
            >
              注册
            </Button>
            <div style={{ marginTop: 16, textAlign: 'center' }}>
              已有账号？ <Link to="/login">立即登录</Link>
            </div>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default RegisterPage;